// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news {
  padding: 7rem 0 0.125rem;
}
@media (max-width: 768px) {
  .news {
    padding: 3.5rem 0 0;
  }
}
.news__header {
  padding: 0 6.875rem;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 3.25rem;
  color: rgba(var(--orange));
  cursor: pointer;
  max-width: max-content;
}
@media (max-width: 768px) {
  .news__header {
    font-size: 1.75rem;
    line-height: 2rem;
    padding: 0 1rem;
  }
}
.news__content {
  margin-top: 1.5rem;
}
.news__spinner {
  margin: 5rem auto;
}
.news__scroll {
  position: relative;
  margin: 1.5rem 1rem 0;
  height: 3px;
  background-color: rgba(var(--grey-100));
}
.news__scroll-item {
  position: absolute;
  height: 3px;
  transition: transform 500ms ease-in-out;
  background-color: rgba(var(--grey-400));
}

.news-swiper {
  position: relative;
  width: 100%;
  height: 100%;
}
.news-swiper:hover .swiper-nav-button {
  opacity: 1;
}

.card {
  background-color: rgba(var(--grey-100));
  border-radius: 0.75rem;
  padding: 1rem;
  cursor: pointer;
}
@media (max-width: 768px) {
  .card {
    padding: 0.75rem;
  }
}
.card__img {
  display: block;
  width: 100%;
  height: 360px;
  object-fit: cover;
  border-radius: 0.75rem;
}
@media (max-width: 2048px) {
  .card__img {
    height: 358px;
  }
}
@media (max-width: 1792px) {
  .card__img {
    height: 307px;
  }
}
@media (max-width: 1536px) {
  .card__img {
    height: 256px;
  }
}
@media (max-width: 1344px) {
  .card__img {
    height: 217px;
  }
}
@media (max-width: 1152px) {
  .card__img {
    height: 179px;
  }
}
@media (max-width: 900px) {
  .card__img {
    height: 165px;
  }
}
.card__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
.card__content-date {
  font-family: var(--merriweather);
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 1.57;
  color: rgba(var(--grey-600));
  margin-top: 1rem;
}
.card__content-title {
  font-family: var(--merriweather);
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.625;
  color: rgba(var(--grey-800));
  margin-bottom: 0.5rem;
  height: 3.5rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
}
.card__content-title_vertical {
  -webkit-box-orient: vertical;
}
@media (max-width: 768px) {
  .card__content-title {
    height: 4.1rem;
    -webkit-line-clamp: 3;
    font-size: 0.875rem;
    line-height: 1.57;
    overflow: hidden;
  }
}

.last-slide {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.last-slide__img {
  height: 70%;
  width: 100%;
}

.news-card-skeleton {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: calc((100vw - 13.75rem - 5.5rem) / 3);
  height: 100%;
  background-color: rgba(var(--white));
}
@media (max-width: 768px) {
  .news-card-skeleton {
    flex-direction: row;
    width: 100%;
    height: calc((100vw - 8px) / 2);
    border-radius: 0.5rem;
  }
}
.news-card-skeleton__content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}
.news-card-skeleton__img {
  position: relative;
  overflow: hidden;
  height: calc((100vw - 13.75rem - 5rem) / 3 / 1.42);
  width: 100%;
  border-radius: 0.75rem;
  background-color: rgba(var(--blue-grey-300));
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .news-card-skeleton__img {
    height: calc((100vw - 8px) / 2);
    width: calc((100vw - 26px) / 2);
    flex-shrink: 0;
    border-radius: 0.5rem;
    margin-bottom: 0;
  }
}
.news-card-skeleton__text {
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 0.25rem;
  height: 1.375rem;
  background-color: rgba(var(--blue-grey-300));
}
@media (max-width: 768px) {
  .news-card-skeleton__text {
    height: 1.5rem;
  }
}
.news-card-skeleton__name {
  position: relative;
  overflow: hidden;
  width: 10rem;
  border-radius: 0.25rem;
  height: 1.625rem;
  background-color: rgba(var(--blue-grey-300));
}
@media (max-width: 768px) {
  .news-card-skeleton__name {
    width: 6rem;
    height: 1.5rem;
  }
  .news-card-skeleton__name:last-child {
    display: none;
  }
}

.news-card-skeleton__img:after,
.news-card-skeleton__text:after,
.news-card-skeleton__name:after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  animation: shimmer 1.4s infinite;
  background-image: linear-gradient(90deg, rgba(var(--white), 0) 0%, rgba(var(--white), 0.2) 20%, rgba(var(--white), 0.5) 60%, rgba(var(--white), 0));
}`, "",{"version":3,"sources":["webpack://./src/components/News/styles.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;AACE;EAHF;IAII,mBAAA;EAEF;AACF;AAAE;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,sBAAA;AAEJ;AAAI;EATF;IAUI,kBAAA;IACA,iBAAA;IACA,eAAA;EAGJ;AACF;AAAE;EACE,kBAAA;AAEJ;AACE;EACE,iBAAA;AACJ;AAEE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,uCAAA;AAAJ;AAEI;EACE,kBAAA;EACA,WAAA;EACA,uCAAA;EACA,uCAAA;AAAN;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAFF;AAIE;EACE,UAAA;AAFJ;;AAMA;EACE,uCAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;AAHF;AAKE;EANF;IAOI,gBAAA;EAFF;AACF;AAIE;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AAFJ;AAII;EAPF;IAQI,aAAA;EADJ;AACF;AAGI;EAXF;IAYI,aAAA;EAAJ;AACF;AAEI;EAfF;IAgBI,aAAA;EACJ;AACF;AACI;EAnBF;IAoBI,aAAA;EAEJ;AACF;AAAI;EAvBF;IAwBI,aAAA;EAGJ;AACF;AADI;EA3BF;IA4BI,aAAA;EAIJ;AACF;AADE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;AAGJ;AADI;EACE,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AAGN;AAAI;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AAEN;AAAM;EACE,4BAAA;AAER;AACM;EAhBF;IAiBI,cAAA;IACA,qBAAA;IACA,mBAAA;IACA,iBAAA;IACA,gBAAA;EAEN;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AAAF;AAEE;EACE,WAAA;EACA,WAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,4CAAA;EACA,YAAA;EACA,oCAAA;AADF;AAGE;EARF;IASI,mBAAA;IACA,WAAA;IACA,+BAAA;IACA,qBAAA;EAAF;AACF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;AAAJ;AAGE;EACE,kBAAA;EACA,gBAAA;EACA,kDAAA;EACA,WAAA;EACA,sBAAA;EACA,4CAAA;EACA,qBAAA;AADJ;AAGI;EATF;IAUI,+BAAA;IACA,+BAAA;IACA,cAAA;IACA,qBAAA;IACA,gBAAA;EAAJ;AACF;AAGE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,4CAAA;AADJ;AAGI;EARF;IASI,cAAA;EAAJ;AACF;AAGE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,4CAAA;AADJ;AAGI;EARF;IASI,WAAA;IACA,cAAA;EAAJ;EAEI;IACE,aAAA;EAAN;AACF;;AAKA;;;EAGE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,4BAAA;EACA,gCAAA;EACA,mJAAA;AAFF","sourcesContent":[".news {\n  padding: 7rem 0 0.125rem;\n\n  @media (max-width: 768px) {\n    padding: 3.5rem 0 0;\n  }\n\n  &__header {\n    padding: 0 6.875rem;\n    font-size: 2.5rem;\n    font-weight: 600;\n    line-height: 3.25rem;\n    color: rgba(var(--orange));\n    cursor: pointer;\n    max-width: max-content;\n\n    @media (max-width: 768px) {\n      font-size: 1.75rem;\n      line-height: 2rem;\n      padding: 0 1rem;\n    }\n  }\n\n  &__content {\n    margin-top: 1.5rem;\n  }\n\n  &__spinner {\n    margin: 5rem auto;\n  }\n\n  &__scroll {\n    position: relative;\n    margin: 1.5rem 1rem 0;\n    height: 3px;\n    background-color: rgba(var(--grey-100));\n\n    &-item {\n      position: absolute;\n      height: 3px;\n      transition: transform 500ms ease-in-out;\n      background-color: rgba(var(--grey-400));\n    }\n  }\n}\n\n.news-swiper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  &:hover .swiper-nav-button {\n    opacity: 1;\n  }\n}\n\n.card {\n  background-color: rgba(var(--grey-100));\n  border-radius: 0.75rem;\n  padding: 1rem;\n  cursor: pointer;\n\n  @media (max-width: 768px) {\n    padding: 0.75rem;\n  }\n\n  &__img {\n    display: block;\n    width: 100%;\n    height: 360px;\n    object-fit: cover;\n    border-radius: 0.75rem;\n\n    @media (max-width: 2048px) {\n      height: 358px;\n    }\n\n    @media (max-width: 1792px) {\n      height: 307px;\n    }\n\n    @media (max-width: 1536px) {\n      height: 256px;\n    }\n\n    @media (max-width: 1344px) {\n      height: 217px;\n    }\n\n    @media (max-width: 1152px) {\n      height: 179px;\n    }\n\n    @media (max-width: 900px) {\n      height: 165px;\n    }\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n\n    &-date {\n      font-family: var(--merriweather);\n      font-weight: 300;\n      font-size: 0.875rem;\n      line-height: 1.57;\n      color: rgba(var(--grey-600));\n      margin-top: 1rem;\n    }\n\n    &-title {\n      font-family: var(--merriweather);\n      font-weight: 300;\n      font-size: 1rem;\n      line-height: 1.625;\n      color: rgba(var(--grey-800));\n      margin-bottom: 0.5rem;\n      height: 3.5rem;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n\n      &_vertical {\n        -webkit-box-orient: vertical;\n      }\n\n      @media (max-width: 768px) {\n        height: 4.1rem;\n        -webkit-line-clamp: 3;\n        font-size: 0.875rem;\n        line-height: 1.57;\n        overflow: hidden;\n      }\n    }\n  }\n}\n\n.last-slide {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  &__img {\n    height: 70%;\n    width: 100%;\n  }\n}\n\n.news-card-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: calc((100vw - 13.75rem - 5.5rem) / 3);\n  height: 100%;\n  background-color: rgba(var(--white));\n\n  @media (max-width: 768px) {\n    flex-direction: row;\n    width: 100%;\n    height: calc((100vw - 8px) / 2);\n    border-radius: 0.5rem;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  &__img {\n    position: relative;\n    overflow: hidden;\n    height: calc((100vw - 13.75rem - 5rem) / 3 / 1.42);\n    width: 100%;\n    border-radius: 0.75rem;\n    background-color: rgba(var(--blue-grey-300));\n    margin-bottom: 0.5rem;\n\n    @media (max-width: 768px) {\n      height: calc((100vw - 8px) / 2);\n      width: calc((100vw - 26px) / 2);\n      flex-shrink: 0;\n      border-radius: 0.5rem;\n      margin-bottom: 0;\n    }\n  }\n\n  &__text {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    border-radius: 0.25rem;\n    height: 1.375rem;\n    background-color: rgba(var(--blue-grey-300));\n\n    @media (max-width: 768px) {\n      height: 1.5rem;\n    }\n  }\n\n  &__name {\n    position: relative;\n    overflow: hidden;\n    width: 10rem;\n    border-radius: 0.25rem;\n    height: 1.625rem;\n    background-color: rgba(var(--blue-grey-300));\n\n    @media (max-width: 768px) {\n      width: 6rem;\n      height: 1.5rem;\n\n      &:last-child {\n        display: none;\n      }\n    }\n  }\n}\n\n.news-card-skeleton__img:after,\n.news-card-skeleton__text:after,\n.news-card-skeleton__name:after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  animation: shimmer 1.4s infinite;\n  background-image: linear-gradient(\n    90deg,\n    rgba(var(--white), 0) 0%,\n    rgba(var(--white), 0.2) 20%,\n    rgba(var(--white), 0.5) 60%,\n    rgba(var(--white), 0)\n  );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
